import React, { useEffect, useRef, useState } from "react";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { useNavigate, Link, useParams } from "react-router-dom";
import { Col, Row, Label, Container } from "reactstrap";

import moment from "moment";
import { defaultIfNull } from "../../../store/Utility/Helper";
import HerosectionHeader from "../../../Componet/Herosection/HerosectionHeader";
import { QuotationStatusData } from "../../../store/Utility/Utility";
import { QuotationStatus, OrderStatus, OrderFilter } from "../../../store/Utility/Status";
import EmptyDataResult from "../../../Componet/EmptyDataResult";
import VehicleTypeIcon from "../../../Componet/VehicleTypeIcon";
import SpinnerButton from "../../../Componet/Button/SpinnerButton";
import { VehicleTypes, OrderCancelationType } from "../../../store/Utility/Status";
import { useSpinner } from "../../../context/SpinnerContext";

import Modal from "react-bootstrap/Modal";
const TrackModalInitialData = {
    show: false,
    data: null
}

const OrderList = () => {
    let { filter } = useParams();

    const [orders, setOrders] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState(filter == OrderFilter.Completed ? OrderStatus.Completed : OrderStatus.AwaitingInspection);
    const [trackingModal, setTrackingModal] = useState(TrackModalInitialData);
    const [loading, setLoading] = useState(false);
    const [validationError, setValidationError] = useState({});
    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();
    const { showLoader, hideLoader } = useSpinner();
    const orderNumber = useRef();
    const customerEmail = useRef();


    const fetchOrders = async () => {
        setLoading(true);
        var selectedItem = QuotationStatusData.find(t => t.id == selectedStatus);
        if (!selectedItem) return;
        await axiosPrivate.get(`v1/tenant/orders`,
            {
                params:
                {
                    status: selectedStatus,
                    orderNumber: orderNumber.current.value?.trim(),
                    orderBy: selectedItem.sorting
                },
            }).then(res => {
                setOrders(res.data.data);
                setLoading(false);
            });

    };

    const onSearchClick = (e) => {
        if (loading) return;
        fetchOrders();
    }

    const handleOptionChange = (e) => {
        setSelectedStatus(e.target.value);
    };

    const getOrderStatus = async (key) => {
        await axiosPrivate.get(`v1/tenant/order-tracking/${key}`).then(res => {
            var response = res?.data.data;

            if (response.status == QuotationStatus.Completed) {
                response.message = "Your inspection report is ready for your review.";
                response.orderReceived = "active";
                response.orderScheduled = "active";
                response.reportSubmitted = "active";
                response.reportAvailable = "active";
                response.inProgressClass = "active";
            } else if (response.status == QuotationStatus.Inspected || response.status == QuotationStatus.InspectionApproved) {
                response.message = "Inspection report is being reviewed and awaiting approval.";
                response.orderReceived = "active";
                response.orderScheduled = "active";
                response.reportSubmitted = "active";
                response.inProgressClass = "active";
            } else if (response.status == QuotationStatus.Assigned) {
                response.message = "Inspector assigned to your inspection.";
                response.orderReceived = "active";
                if (response.appointmentDate != null) {
                    response.orderScheduled = "active";
                }
            } else if (response.status == QuotationStatus.Created) {
                response.message = "Your order is received.";
                response.orderReceived = "active";
            }
            else if (response.status == QuotationStatus.Cancelled) {
                response.message = "Your order has been canceled.";
            }

            setTrackingModal((prev) => ({ ...prev, show: true, data: response }));
        }).catch(error => {
        });
        
    };

    useEffect(() => {
        fetchOrders();
    }, [])

    return (<>
        <HerosectionHeader name={"Orders"} />
        {
            <Modal show={trackingModal?.show} onHide={() => setTrackingModal(TrackModalInitialData)}>
                <Modal.Header closeButton>
                    <Modal.Title>Order : {trackingModal?.data?.orderNumber} </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row >
                            <Col md={12} className={`border rounded ${trackingModal?.data?.status == QuotationStatus.Cancelled ? 'text-center' : ''}`}>
                                <div className="p-2">
                                    <h4>Track Status of Your Inspection</h4>
                                    {trackingModal?.data?.status != QuotationStatus.Cancelled ? <div className="progress-container">
                                        <div className={`step ${trackingModal?.data?.orderReceived}`}>
                                            <div className="circle">
                                                <i className="la la-clipboard-check"></i>
                                            </div>
                                            <div className="label">Order Received</div>
                                        </div>
                                        <div className={`step ${trackingModal?.data?.orderScheduled}`}>
                                            <div className="circle"> <i className="la la-calendar"></i></div>
                                            <div className="label">Scheduled</div>
                                        </div>
                                        {/* <div className={`step ${data?.inProgressClass}`}>
                                            <div className="circle"> <i className='la la-search'></i></div>
                                            <div className="label">In Progress</div>
                                        </div> */}
                                        <div className={`step ${trackingModal?.data?.reportSubmitted}`}>
                                            <div className="circle"><i className='la la-clipboard-list'></i></div>
                                            <div className="label">Completed</div>
                                        </div>
                                        <div className={`step ${trackingModal?.data?.reportAvailable}`}>
                                            <div className="circle"><i className='la la-desktop'></i></div>
                                            <div className="label">Report Available</div>
                                        </div>
                                    </div>
                                        :
                                        <div className='row'>
                                            <div><i className='la la-5x text-danger la-times-circle'></i></div>
                                        </div>
                                    }
                                    <div className="status-message">
                                        <p><strong> {trackingModal?.data?.message}</strong></p>
                                    </div>
                                    <div className="order-details">
                                        <p>Vehicle: <strong>{trackingModal?.data?.year} {trackingModal?.data?.make} {trackingModal?.data?.model}</strong></p>
                                        {trackingModal?.data?.status != QuotationStatus.Cancelled && <p>Assigned Inspector: <strong>{trackingModal?.data?.assignedInspector != null ? trackingModal?.data.assignedInspector : 'Pending assignment'}</strong></p>}
                                        {trackingModal?.data?.status != QuotationStatus.Cancelled && <p>Appointment Date: <strong>{trackingModal?.data?.appointmentDate != null ? moment(trackingModal?.data?.appointmentDate).format('MM.DD.YYYY') : 'To be scheduled'}</strong></p>}
                                    </div>
                                    {trackingModal?.data?.status == QuotationStatus.Completed &&
                                        <Row>
                                            <Link className="btn btn-dark" to={`/report/${trackingModal?.data?.id}`}>View Report</Link>
                                        </Row>
                                    }
                                    {trackingModal?.data?.status < QuotationStatus.Completed && <span style={{ fontStyle: "italic", fontSize: "14px" }}>* The appointment date shown is estimated and subject to change.</span>}
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Row>
                        <Col md={2}></Col>
                        <Col md={4}><button className="btn btn-primary" onClick={() => setTrackingModal(TrackModalInitialData)}>Close</button></Col>
                    </Row>

                </Modal.Footer>
            </Modal>
        }

        <div className="container">
            <Row>
                <Col md={2}> <div className="mt-5 d-flex align-items-center">
                    <input type="text" ref={orderNumber} className="form-control" name="orderNumber"
                        placeholder="Order Number" />
                </div>
                </Col>
                <Col md={2}>
                    <div className="mt-5 d-flex align-items-center">
                        <select
                            className="form-select"
                            id="inputGroupSelect02"
                            onChange={handleOptionChange}
                            value={selectedStatus}
                        >
                            {/* {QuotationStatusData && QuotationStatusData.length > 0 && QuotationStatusData.map((m, i) => (
                                <option key={i} value={m.id}>{m.displayName}</option>
                            ))} */}
                            <option key="0" value="0">All</option>
                            <option key="2" value="2">Awaiting Inspection</option>
                            <option key="4" value="4">Completed</option>
                        </select>
                    </div>
                </Col>
                <Col md={2}>
                    <div className="mt-5 d-flex">
                        {/* <button type="button" className="btn btn-primary btn-sm" onClick={onSearchClick} >Search</button> */}
                        <SpinnerButton type="button" className="btn btn-primary btn-sm w-100 w-md-auto" loading={loading} onClick={onSearchClick} text="Search" />
                    </div>
                </Col>
                <Col md={2}></Col>
                <Col md={2}></Col>
                <Col md={2}>
                    <div className="mt-5 d-flex">
                        <Link className='btn btn-dark btn-sm w-100 w-md-auto' to="/new-order"><i className="las la-file-alt la-lg me-1"></i> New Order</Link>
                    </div>
                </Col>
            </Row>
            <div className="row">
                <div className="col">
                    {(orders && orders.length > 0) ?
                        orders.map((item, index) => ((
                            <div key={index} className="card bg-transparent flex-md-row align-items-center p-md-0 3 mt-3 mb-3">
                                <div className="col-md-2">
                                    <div className="bg-primary p-2 d-inline-block rounded m-4">
                                        <div className="f-icon-m text-white">
                                            <VehicleTypeIcon vehicleType={item.vehicleType} />
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body col-md-8">
                                    <div>
                                        <div><span><strong>Order: </strong>{defaultIfNull(item.orderNumber)}</span>  <span className={"mx-3 " + (item.status == QuotationStatus.Completed ? "badge bg-primary" : "badge bg-secondary")}> {item.status == QuotationStatus.Completed ? "Completed" : "Awaiting Inspection"} </span></div>
                                        <div><span><strong>{item.make} / {item.model} / {item.year}</strong></span></div>
                                        <div><span><strong>VIN: </strong>{defaultIfNull(item.vin)}</span></div>
                                        <div><span><strong>Seller: </strong>{item.sellerContactName}</span></div>
                                        <div><span><strong>Seller Phone: </strong>{item.sellerPhone}</span></div>
                                        <div><span><strong>Vehicle Address: </strong>{item.sellerAddress}</span></div>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="d-flex flex-column gap-2 m-2">
                                        {item.status < QuotationStatus.Completed && <button className="btn btn-secondary" onClick={() => getOrderStatus(item.publicKey)}>Track Order</button>}
                                        {item.status == QuotationStatus.Completed && <Link className="btn btn-primary" aria-label="Customer Report" to={`/report/${item.publicKey}`} target='_blank'
                                        >View Report</Link>}
                                    </div>
                                </div>
                            </div>))) : <div> <EmptyDataResult message="There is no data to display" /></div>
                    }
                </div>
            </div>
        </div>
    </>);

}

export default OrderList;